import React from "react";
import { Spin } from "antd";
import { PushpinFilled, PushpinOutlined } from "src/icons";
import Tabs, { TabData } from "src/shared/components/Tabs";

import OverviewCard from "./OverviewCard";
import styles from "./index.module.scss";
// import { TabNames } from "src/shared/config";
import { TabNames } from "src/api/common";
import { safeGet } from "src/shared/utils";
import { ISinglePin } from "src/shared/types";
import { ManageMetricIcon } from "src/assets/manage-metric.js";

interface IPinnedContainerProps {
  selectedTab: any;
  isPulledUp: boolean;
  showDetails(id: any, name: string): void;
  isPending: boolean;
  onChangeTab(any): void;
  pins: {
    errors: any;
    failure: boolean;
    payload: {
      hasMore: boolean;
      pageNo: number;
      pageSize: number;
      data: ISinglePin[];
    };
    pending: boolean;
    success: boolean;
  };
  switchToManageMetrics(val: boolean): void;
}

const PinnedContainer = (props: IPinnedContainerProps) => {
  const { showDetails, pins, onChangeTab } = props;

  const handleTabChange = (tabData: TabData) => {
    onChangeTab({ label: tabData.key });
  };

  const rawPinsData = safeGet(pins, "payload.data", []);
  const pinsData: ISinglePin[] = Array.isArray(rawPinsData) ? rawPinsData : [];

  return (
    <main className={styles["pinned-container"]}>
      <div className={styles["pin-header"]}>
        <PushpinFilled />
        <div>
          <div className={styles["pin-header-text"]}>My focus metrics</div>
        </div>
        <ManageMetricIcon onClick={() => props.switchToManageMetrics(true)} />
      </div>
      {pinsData.length ? (
        <Tabs
          tabs={TabNames.map((tabName) => ({ title: tabName, key: tabName }))}
          page={props.selectedTab}
          onChange={handleTabChange}
        >
          {TabNames.map((tabName) => (
            <div key={tabName}>
              {pinsData.map((cardItem) => {
                return (
                  <OverviewCard
                    data={cardItem}
                    key={cardItem.id}
                    id={cardItem.id}
                    showDetails={showDetails}
                    failure={safeGet(pins, "failure", false)}
                    pending={safeGet(pins, "pending", false)}
                    selectedTab={props.selectedTab}
                  />
                );
              })}
            </div>
          ))}
        </Tabs>
      ) : (
        <>
          {safeGet(pins, "success", false) && (
            <div className={styles["no-pin"]}>
              <p>Pin the metrics you want to focus on here</p>
              <p>
                Tap <PushpinOutlined /> on a metric page
              </p>
            </div>
          )}
          {safeGet(pins, "pending", false) && (
            <div className={styles["spinner"]}>
              <Spin />
            </div>
          )}
          {safeGet(pins, "failure", false) && <div className={styles["no-pin"]}>Couldn't fetch data !</div>}
        </>
      )}
      {safeGet(pins, "pending", false) && pinsData.length > 0 && (
        <div className={styles["spinner"]}>
          <Spin />
        </div>
      )}
    </main>
  );
};

export default PinnedContainer;
